<template>
  <div ref="printMe">
    <cusHeader></cusHeader>
    <b-container v-if="step===0">
      <h3 class="mt-3 mb-4">Informe de la consulta</h3>
      <Report ref="customReport"></Report>
      <b-row align-h="end">
        <b-button variant="outline-info" @click="cancelAndReturn">Cancelar y volver</b-button>
        <b-button class='ml-2' @click="skipReport" variant="outline-danger">Omitir informe y continuar</b-button>
        <b-button class='ml-2' @click="gotoTreatment" variant="primary">Continuar</b-button>
      </b-row>
    </b-container>
    <b-container v-else-if="step===1">
      <h3 class="mt-3 mb-4">Tratamiento</h3>
      <Treatment ref="customTreatment"></Treatment>
      <b-row align-h="end">
        <b-button variant="outline-info" @click="returnReport">atrás</b-button>
        <b-button class='ml-2' @click="show_dialogCommitTreatment" variant="primary">Finalizar</b-button>
      </b-row>
    </b-container>
    <base-dialog v-model = "dialogCommitTreatment" 
      :okFn = "dialogCommitTreatment_okFn" 
      :cancelFn = "dialogCommitTreatment_cancelFn"
      okBtnText = "Aceptar"
      cancelBtnText = "Cancelar"
      content = "¿Desea finalizar y enviar el tratamiento?">
    </base-dialog>
  </div>
</template>

<script>
import SideBar from '@/components/webapp/professional/sideBar.vue'
import Report from '@/components/webapp/professional/report.vue'
import Prescription from '@/components/webapp/professional/prescription.vue'
import Patient from '@/components/webapp/professional/patient.vue'
import Treatment from '@/components/webapp/professional/treatment.vue'
import cusHeader from '@/components/layouts/professional/customHeader.vue'
import PrescriptionList from '@/components/webapp/professional/PrescriptionList'
import { BTabs, BTab, BRow, BButton, BNav } from 'bootstrap-vue'
// Route: /webapp/professional/es-nodofarma
export default {
  name: 'EsNodofarma',
  components: {
    'base-dialog': () => import('@/components/base/BaseDialog'),
    SideBar,
    cusHeader,
    Prescription,
    Patient,
    Report,
    PrescriptionList,
    Treatment,
    BTab,
    BTabs,
    BRow,
    BButton,
    BNav
  },
  data () {
    return {
      dialogCommitTreatment: false,
      step: 0,
      report: {},
      captureScreen: null,
      treatment: {}
    }
  },
  created () {
    if (!this.$route.params.patient) {
      this.patient = 'Paco'
    } else {
      this.patient = this.$route.params.token
    }
  },
  methods: {
    skipReport () {
      this.report = this.$refs.customReport.report
      this.step = 1
    },
    gotoTreatment () {
      this.report = this.$refs.customReport.report
      this.report.filled = true
      this.step = 1
    },
    returnReport () {
      this.step = 0
    },
    sendNodofarmaData () {
      this.treatment = this.$refs.customTreatment.newPrescription
      this.$nodofarmaApi.post('Tratamiento/CreateTratamiento', this.report, this.treatment)
    },
    dialogCommitTreatment_okFn () {
      console.log('send data')
      this.dialogCommitTreatment = false
      this.print()
    },
    dialogCommitTreatment_cancelFn () {
      this.dialogCommitTreatment = false
    },
    show_dialogCommitTreatment () {
      this.dialogCommitTreatment = true
    },
    cancelAndReturn () {
      // TODO: Return to opensalud
      console.log('Return to opensalud')
    },
    async print () {
      // et el = document.getElementById('nodofarma')
      const el = this.$refs.printMe
      const options = {
        type: 'dataURL'
      }
      this.captureScreen = await this.$html2canvas(el, options)
    }
  }
}
</script>

<style lang="less">
body {
  text-align:left !important;
}
h3 {
   font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/webapp/professional/EsNodofarma.vue